import React, { useEffect, useState, useRef } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  IconButton,
  Alert,
  AlertTitle,
  Typography,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import UploadFileIcon from "@mui/icons-material/CloudUpload";
import { createCategory, updateCategory } from "../../services/categoryFn";
import CustomSnackbar from "../../components/customSnackBar/customSnackBar";
import AppLoader from "../../components/loader/loader";

const CategoryAdd = ({
  open,
  onClose,
  type = "add",
  categoryData = {},
  fetchCategories,
  title,
  setTitle,
  image,
  setImage,
}) => {
  const [loading, setLoading] = useState(false);
  const snackRef = useRef();
  const fileInputRef = useRef(); // Defined file input ref

  const handleOpenSnack = (status, message) => {
    snackRef.current.isOpenSnack({
      snackType: status,
      snackMessage: message,
    });
  };

  useEffect(() => {
    if (type === "edit" && categoryData) {
      setTitle(categoryData.name || "");
      setImage(categoryData.image || null);
    } else {
      setTitle("");
      setImage(null);
    }
  }, [type, categoryData]);

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];

    if (!file) return;

    const img = new Image();
    img.src = URL.createObjectURL(file);

    img.onload = async () => {
      const width = img.width;
      const height = img.height;
      const aspectRatio = width / height;

      console.log("Aspect Ratio:", aspectRatio);

      if (aspectRatio !== 1) {
        handleOpenSnack(
          "error",
          "Please upload an image with a 1:1 aspect ratio."
        );
        return;
      }

      const formData = new FormData();
      formData.append("file", file);
      formData.append("upload_preset", "b1f5s93m");
      setLoading(true);
      try {
        const result = await fetch(
          "https://api.cloudinary.com/v1_1/dofa5sctg/image/upload",
          {
            method: "POST",
            body: formData,
          }
        );

        const data = await result.json();

        if (data.secure_url) {
          setImage(data.secure_url);
          setLoading(false);
        }
      } catch (error) {
        console.error("Cloudinary upload error:", error);
      }
    };
  };

  const handleSubmit = async () => {
    if (!title || !image) {
      handleOpenSnack("error", "Title and Image are required!");
      return;
    }
    setLoading(true);

    try {
      const categoryPayload = { name: title, image };
      let response;

      if (type === "edit") {
        response = await updateCategory(categoryData._id, categoryPayload);
      } else {
        response = await createCategory(categoryPayload);
      }

      if (response.data.status === "success") {
        console.log(response, "responseresponse");
        handleOpenSnack(
          "success",
          type === "edit"
            ? "Category updated successfully"
            : "Category added successfully"
        );
        setTitle("");
        setImage(null);
        setLoading(false);
        onClose();

        fetchCategories();
      }
    } catch (error) {
      console.error("Error saving category:", error);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <CustomSnackbar ref={snackRef} /> {/* Snackbar for feedback */}
      <AppLoader isVisible={loading} />
      <DialogTitle>
        {type === "add" ? "Add Category" : "Edit Category"}
        <IconButton
          onClick={onClose}
          style={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
          <div
            style={{
              textAlign: "center",
              padding: "16px",
              border: "2px dashed #ccc",
              borderRadius: "8px",
              cursor: "pointer",
              width: "70%",
            }}
            onClick={() => fileInputRef.current?.click()}
          >
            <input
              ref={fileInputRef}
              type="file"
              accept="image/*"
              onChange={handleImageUpload}
              style={{ display: "none" }}
            />
            <UploadFileIcon fontSize="large" color="action" />
            <Typography variant="body2" color="textSecondary">
              Click to upload or drag and drop
            </Typography>
            <Typography variant="caption" color="textSecondary">
              PNG, JPG up to 5MB
            </Typography>
          </div>

          {image && (
            <div style={{ textAlign: "center", width: "28%" }}>
              <img
                src={image}
                alt="Preview"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: "8px",
                }}
              />
            </div>
          )}
        </div>

        <TextField
          fullWidth
          label="Category Name"
          variant="outlined"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          margin="normal"
        />
      </DialogContent>
      <DialogActions sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Button variant="outlined" sx={{ width: "100px" }} onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant="contained"
          sx={{ width: "200px" }}
          onClick={handleSubmit}
        >
          {type === "add" ? "Add Category" : "Update Category"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CategoryAdd;
